import * as Yup from "yup";
import { isSocialLinkValid } from "../../../../../../utils/socialHelpers";

export const profileBoxInitialValues = {
  firstName: "",
  lastName: "",
  bio: "",
  profile_image: "",
  username: "",
  // showNumberOfWheels: false,
  // business_link: [],
  // external_links: [
  //   { title: "", link: "", icon: "", is_cta_enabled: false },
  //   { title: "", link: "", icon: "", is_cta_enabled: false },
  // ],
};

export const profileBoxValidationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required("First Name is required"),
  lastName: Yup.string().trim().required("Last Name is required"),
  bio: Yup.string().trim(),
  profile_image: Yup.string().trim(),
  description: Yup.string().trim(),
  username: Yup.string()
    .trim()
    .max(30, "Profile Name must be less than 30 characters")
    .matches(/^\S*$/, "Profile Name cannot contain spaces"),
  // external_links: Yup.array().of(
  //   Yup.object().shape({
  //     title: Yup.string().when("is_cta_enabled", {
  //       is: true,
  //       then: (schema) => schema.required("A title is required"),
  //       otherwise: (schema) => schema,
  //     }),
  //     link: Yup.string().when("is_cta_enabled", {
  //       is: true,
  //       then: (schema) => schema.required("A link is required"),
  //       otherwise: (schema) => schema,
  //     }),
  //     is_cta_enabled: Yup.boolean().required(), // Ensure this field exists
  //   })
  // ),
  // business_link: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       platform: Yup.string().required("Platform is required"),
  //       link: Yup.string()
  //         .nullable()
  //         .transform((value) => value?.trim() || null)
  //         .test(
  //           "is-valid-link-for-platform",
  //           "Invalid URL for the selected platform.",
  //           function (value) {
  //             const { platform } = this.parent;
  //             try {
  //               return isSocialLinkValid(value, platform);
  //             } catch (error) {
  //               return false; // Return false for unsupported platforms
  //             }
  //           }
  //         ),
  //     })
  //   )
  //   .default([]),
});
